export function confirm(config){
	return webix.confirm(
		webix.extend(
			{
				container: this.$view,
				css:"webix_ssheet_confirm",
				ok: webix.i18n.spreadsheet.labels.ok,
				cancel: webix.i18n.spreadsheet.labels.cancel
			},
			config,
			true
		)
	);
}

export function alert(config){
	return webix.alert(
		webix.extend(
			{
				container: this.$view,
				css: "webix_ssheet_alert",
				ok: webix.i18n.spreadsheet.labels.ok
			},
			config,
			true
		)
	);
}